import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IWidgetConfigComponent } from 'src/app/models/dashboard/dashboard-widget.model';
import { SegProfileSummaryFiltersComponent } from './seg-profile-summary-filters.component';
import {
    SegProfileFilterValues,
    SEG_PROFILE_FILTER_DEFAULTS,
    configToFilterValues,
    filterValuesToConfig,
} from './seg-profile-summary-widget.constants';

@Component({
    standalone: true,
    selector: 'app-seg-profile-summary-widget-config',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SegProfileSummaryFiltersComponent],
    templateUrl: './seg-profile-summary-widget-config.component.html',
    styleUrls: ['./seg-profile-summary-widget-config.component.scss']
})
export class SegProfileSummaryWidgetConfigComponent
    implements OnInit, IWidgetConfigComponent
{
    @Input() config: Record<string, unknown> = {};
    @Output() configChange = new EventEmitter<Record<string, unknown>>();

    filterValues: SegProfileFilterValues = { ...SEG_PROFILE_FILTER_DEFAULTS };

    ngOnInit(): void {
        this.filterValues = configToFilterValues(this.config);
    }

    onFilterChange(values: SegProfileFilterValues): void {
        this.filterValues = values;
        this.configChange.emit(filterValuesToConfig(values));
    }
}
